import { useCallback } from 'react';
import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';
// TODO: replace with useLazyQuery which returns a promise when apollo is upgraded to v3
//todo: this needs to handle or pass the error
export const useImperativeQuery = <TQuery, TVars extends Record<string, any>>(query: any) => {
	const { refetch } = useQueryInterop<TQuery, TVars>(query, { skip: true });
	const imperativelyCallQuery = useCallback(
		(variables: TVars) => {
			return refetch(variables);
		},
		[refetch],
	);

	return imperativelyCallQuery;
};
